import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BuscadorHallazgosFiltroService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Hallazgo/BusquedaFiltroGestionHallazgo",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { BuscadorHallazgosFiltroService };